// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetInitialSubscriptionRequestRequestModel from '../../model/get-initial-subscription-request-request-model';
import GetInitialSubscriptionRequestRequestDTO from '../dto/get-initial-subscription-request-request-dto';
import dtoSchema from '../schemas/get-initial-subscription-request-request-schema';

export default abstract class GetInitialSubscriptionRequestRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetInitialSubscriptionRequestRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetInitialSubscriptionRequestRequestDTO>): GetInitialSubscriptionRequestRequestModel;
  static toModel(dto: DeepPartial<GetInitialSubscriptionRequestRequestDTO> | undefined | null): GetInitialSubscriptionRequestRequestModel | undefined;
  static toModel(dto: DeepPartial<GetInitialSubscriptionRequestRequestDTO> | undefined | null): GetInitialSubscriptionRequestRequestModel | undefined {
    return dto ? new GetInitialSubscriptionRequestRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetInitialSubscriptionRequestRequestModel> | GetInitialSubscriptionRequestRequestModel): GetInitialSubscriptionRequestRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetInitialSubscriptionRequestRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetInitialSubscriptionRequestRequestModel, can not map to GetInitialSubscriptionRequestRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
